import { Directive, HostBinding } from '@angular/core';

@Directive({
  // tslint:disable:directive-selector
  selector: '[ls-bodySmall]'
})
export class BodySmallDirective {
  @HostBinding('class.cr-text--body-small') public small = true;
}
